'use strict';

var defaults = require ('../../defaults/Defaults');
var Log = require('../../log/Log');
var log = Log.channel('DeveloperInfoController');
require('./DeviceService');
require('./RoomService');
require('./SharedPrefs');
var sutl = require('../../sutl/Sutl');

/* global AveoRestart */

angular.module('inara')
.controller('DeveloperInfoController', DeveloperInfoController);

function inject($injector, name, envs) {
    return envs.includes(process.env.appEnv) ? $injector.get(name) : null;
}

DeveloperInfoController.$inject = [ '$injector', '$window', 'ionicMaterialInk',
    'RoomService', 'SharedPrefs' ];

function DeveloperInfoController($injector, $window, ionicMaterialInk,
    RoomService, SharedPrefs) {

    log.info('initializing');

    var DeviceService = inject($injector, 'DeviceService', [ 'cordova' ]);

    ionicMaterialInk.displayEffect({ duration: defaults.inara.inkDuration });

    var vm = this;
    vm.databases = [
        { id: 'serenity', name: 'Serenity' },
        { id: 'persephone', name: 'Persephone' },
        { id: 'haven', name: 'Haven' },
        { id: 'higgins', name: 'Higgins' },
        { id: 'ariel', name: 'Ariel' }
    ];

    vm.database = 'serenity';
    vm.useSystemLogs = false;

    SharedPrefs.getString('firebaseAlias', 'serenity')
    .then(function(firebaseAlias) {
        vm.database = firebaseAlias;
    });

    SharedPrefs.getBoolean('useSystemLogs', false)
    .then(function(useSystemLogs) {
        vm.useSystemLogs = useSystemLogs;
    });

    if (process.env.appEnv === 'cordova') {
        // The window.performance.memory object is a Chrome-only extension,
        // but we are using it to gather information for Inara on Cordova.
        vm.memory = $window.performance.memory;
    }

    vm.isBrowser = function() {
        return !angular.isDefined($window.cordova);
    };

    vm.onDatabaseChanged = function() {
        if (DeviceService === null) {
            log.error('changing databases not supported on this platform');
            return;
        }

        log.debug('changing database to: ' + vm.database);
        SharedPrefs.setString('firebaseAlias', vm.database)
        .then(function() {
            log.debug('restarting application');
            AveoRestart.restartApplication(1000);
        });
    };

    vm.onUseSystemLogsChanged = function() {
        log.debug('changing useSystemLogs to: ' + vm.useSystemLogs);
        SharedPrefs.setBoolean('useSystemLogs', vm.useSystemLogs)
        .then(function() {
            log.debug('restarting application');
            AveoRestart.restartApplication(1000);
        });
    };

    vm.causeAnr = function() {
        if (DeviceService === null) {
            log.error('causeAnr not supported on this platform');
            return;
        }

        log.debug('causing ANR');
        DeviceService.causeAnr();
    };

    vm.restartApplication = function() {
        if (DeviceService === null) {
            log.error('restart not supported on this platform');
            return;
        }

        log.debug('restarting application');
        AveoRestart.restartApplication(1000);
    };

    vm.enableFactoryInstallMode = function() {
        var controller = RoomService.getController();
        controller.settings.factoryInstallMode = true;
        controller.$save(false);
    };

    vm.throwException = function(thread) {
        if (DeviceService === null) {
            log.error('throwing exceptions not supported on this platform');
            return;
        }

        DeviceService.throwException(thread);
    };

    vm.getKioskModeEnabled = function() {
        var controller = RoomService.getController();
        return sutl.getNode(controller, 'settings.kioskModeEnabled',
            defaults.inara.kioskModeEnabled);
    };

    vm.toggleKioskModeEnabled = function() {
        var controller = RoomService.getController();
        var kioskModeEnabled = sutl.getNode(controller, 'settings.kioskModeEnabled',
            defaults.inara.kioskModeEnabled);
        sutl.setNode(controller, 'settings.kioskModeEnabled',
            !kioskModeEnabled);
        controller.$save();
    };
}

module.exports = DeveloperInfoController;
